import { useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'

import { Paper, Typography } from '@material-ui/core'

import Form from '../component/authen/login/Form'
import useTranslate from '../i18n/useTranslate'
import LayoutPublic from '../component/web/layout/layoutPublic'
import { useLocation, useHistory } from 'react-router-dom'
import { useState } from 'react'
import useLogin, { LoginFormT, ProfileT } from '../services/authen/useLogin'
import authenAction from '../stores/authen/authenAction'
import { RoutePath, lstPrivateRoutes } from '../router/routesConfig'
import { encryption, replaceForDecryptStr } from '../utilities/encryption'
import usePDPA from '../services/authen/usePDPA'
import ModalPDPA from '../component/um/PDPA/ModalPDPA'

import useLoading from '../control/loading/useLoading'
import Dialog, { DialogType } from '../control/dialog/dialog'
import React from 'react'
import useAuthenService from '../services/authen/useAuthenService'
import { addDays } from '../utilities/date'
import { enc } from 'crypto-js'
const Login = () => {
    const classes = useStyles()
    const translate = useTranslate()
    const history = useHistory()
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'
    const location = useLocation()

    const loadingHook = useLoading()
    const autAction = authenAction()
    const authenService = useAuthenService()
    const accessTokenRef = useRef<string>()
    const loginTypeRef = useRef<string>()
    const profileRef = useRef<ProfileT>()
    const [openPDPA, setOpenPDPA] = useState(false)
    const [PDPA, setPDPA] = useState<string>('')

    const { post, getProfile } = useLogin()
    const { getByUser, accept } = usePDPA()

    const [displayPW, setDisplayPW] = useState(false)

    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()

    React.useEffect(() => {
        // const now = new Date('')
        // console.log('now', now)

        // console.log('now.getTime()', now.getTime())

        // var timestamp = 1634025166199
        // var date = new Date(timestamp)
        // console.log(date.getTime())
        // console.log(date)

        // const expireDate = addDays(new Date(), 7)
        // console.log('expireDate', expireDate)

        // var date = new Date(expireDate.getTime())
        // console.log('timeStamp==>', expireDate.getTime())
        // console.log('myDate==>', date)
        checkIsLogined()
    }, [])

    const defaultOpenPage = (userPermission: ProfileT['permission']) => {
        if (userPermission.length > 0) {
            const functionID = userPermission[0].functionID
            let defaultRoutePath = ''
            lstPrivateRoutes.every((itm) => {
                if (itm.functionID === functionID) {
                    defaultRoutePath = itm.path
                    return false
                }
                return true
            })

            history.push(defaultRoutePath)
        } else {
            //No permision
            history.replace(RoutePath.login, null)
        }
    }

    const checkIsLogined = async () => {
        console.log('============Login.tsx===============')
        const accessToken = localStorage.getItem('accessToken')
        if (accessToken) {
            // const mockCurrentDate = new Date('October 21, 2021 11:13:00')
            const expireDate = localStorage.getItem('tokenExpireDate')
            const currentDate = new Date()

            if (expireDate && currentDate.getTime() > Number(expireDate)) {
                console.log('Token Has Expire')
                localStorage.clear()
                history.replace(RoutePath.login, null)
            } else {
                const loginType = localStorage.getItem('loginType')
                try {
                    const profileRes = await getProfile(accessToken, loginType as unknown as 1 | 2)
                    if (profileRes && profileRes.userId) {
                        defaultOpenPage(profileRes.permission ?? [])
                    } else {
                        // ต้องล้าง accessToken ด้วย ไม่งั้น renderLogin() คืน <div></div> ว่างค้าง
                        localStorage.clear()
                        history.replace(RoutePath.login, null)
                    }
                } catch (error) {
                    // เดิมไม่มี catch error ที่ไม่ใช่ 401 จะค้างที่หน้าว่าง refresh ก็ไม่หาย
                    console.error('checkIsLogined failed:', error)
                    localStorage.clear()
                    history.replace(RoutePath.login, null)
                }
            }
        }
    }

    const displayControl = () => {
        setDisplayPW(!displayPW)
    }

    const decodeDownloadLink = (encodedDownloadLink: string): any => {
        let downloadLink = ''
        try {
            const replacedDecryptStr = replaceForDecryptStr(encodedDownloadLink)
            const encodedWord = enc.Base64.parse(replacedDecryptStr)
            downloadLink = enc.Utf8.stringify(encodedWord)
        } catch (err) {
            console.log('err', err)
        }

        return downloadLink
    }

    const welcome = () => {
        if (profileRef.current && accessTokenRef.current) {
            const expireDate = addDays(new Date(), 7)
            localStorage.setItem('accessToken', accessTokenRef.current)
            localStorage.setItem('loginType', String(loginTypeRef.current))
            localStorage.setItem('tokenExpireDate', String(expireDate.getTime()))

            autAction.setProfile(profileRef.current)

            defaultOpenPage(profileRef.current?.permission ?? [])

            const urlParams = new URLSearchParams(location.search)
            const encodedDownloadLink = urlParams.get('download_link')

            if (encodedDownloadLink) {
                const downloadLink = decodeDownloadLink(encodedDownloadLink)
                window.location.assign(downloadLink)
            }
        }
    }

    const getUserProfile = async (token: string, loginType: 1 | 2) => {
        const profileRes = await getProfile(token, loginType)
        profileRef.current = profileRes
        loginTypeRef.current = String(loginType)

        checkPDPA(`${profileRes.userId}`)
    }

    const checkPDPA = async (userId: string) => {
        welcome()
        console.log('WAIT PDPA FOR OPEN COMMENT')
        //WAIT PDPA FOR OPEN COMMENT
        // const getPDPA = await getByUser(userId)
        // if (getPDPA.isCurrentVersion) {
        //     welcome()
        // } else {
        //     const template = lang === 'th' ? getPDPA.template_th : getPDPA.template_en
        //     setOpenPDPA(true)
        //     setPDPA(template)
        // }
    }

    const login = async (values: LoginFormT) => {
        try {
            loadingHook.loadingOpen()
            const loginType = Number(values.type) as 1 | 2
            const result = await post({
                ...values,
                password: encryption(values.password),
                salt: Buffer.from(values.password).toString('base64'),
            })
            if (result.message === 'incorrect') {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.ERROR'),
                    content: translate.get('UM.LOGIN.INCORRECT'),
                    type: 'alert-message',
                })
                dialogTwoRef.current?.openDialog()
            }

            if (result.message === 'not permission') {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.ERROR'),
                    content: translate.get('UM.LOGIN.NOT-PERMISSION'),
                    type: 'alert-message',
                })
                dialogTwoRef.current?.openDialog()
            }

            if (result.accessToken) {
                accessTokenRef.current = result.accessToken
                await getUserProfile(result.accessToken, loginType)
            }
        } finally {
            loadingHook.loadingClose()
        }
    }

    const onClose = () => {
        setOpenPDPA(false)
        setPDPA('')
    }

    const onAccept = async () => {
        const result = await accept(`${profileRef.current?.userId}`)

        if (result.message === 'success') {
            welcome()
        }
    }

    const goToRegister = () => {
        history.push(RoutePath.register)
    }

    const goToForgotPW = () => {
        history.push(RoutePath.forgotPassword)
    }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    const renderLogin = () => {
        const accessToken = localStorage.getItem('accessToken')
        if (accessToken) {
            return <div></div>
        } else {
            return (
                <LayoutPublic>
                    <Container maxWidth={'md'} className={classes.rootContainer}>
                        <div style={{ display: 'grid', justifyContent: 'center', alignContent: 'center' }}>
                            <Grid container justify="center" alignContent="center" className={classes.root}>
                                <Grid item xs={12} md={10} lg={8} className={classes.item}>
                                    <Paper className={classes.paper}>
                                        <Grid container className={classes.container}>
                                            <Grid item xs={12}>
                                                <img
                                                    src={
                                                        process.env.PUBLIC_URL +
                                                        '/img/Chulalongkorn_University_Alt_Logo.svg.png'
                                                    }
                                                    width={'auto'}
                                                    height="60px"
                                                    alt="chula"
                                                />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Typography className={classes.typo}>
                                                    {translate.get('UM.LOGIN.HEADER')}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Form
                                                    onClickDisplayControl={displayControl}
                                                    displayPW={displayPW}
                                                    onSubmit={login}
                                                    onClickForgotPW={goToForgotPW}
                                                    onClickRegister={goToRegister}
                                                />
                                            </Grid>
                                            <ModalPDPA
                                                open={openPDPA}
                                                consent={PDPA}
                                                onClose={onClose}
                                                onAccept={onAccept}
                                            />
                                            <Dialog onRef={onRefDialogTwo} {...configDialog} />
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </div>
                    </Container>
                </LayoutPublic>
            )
        }
    }

    return renderLogin()
}

const useStyles = makeStyles((theme) => ({
    rootContainer: {
        display: 'flex',
        alignItems: 'center',
        minHeight: 'calc(100vh - 96px)',
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
            padding: '0px',
        },
    },
    root: {
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            height: '100%',
        },
    },
    item: {
        [theme.breakpoints.down('sm')]: {
            height: '100%',
        },
    },
    paper: {
        width: '100%',
        // maxHeight: 'calc(100vh - 80px)',

        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
        },
    },
    container: {
        padding: '1.5rem',
    },
    typo: {
        fontWeight: 'bold',
    },
}))

export default Login
